
export const sanitizeLabeledStrings = (labeledStrings) => {
    return labeledStrings ? labeledStrings.map(sanitizeLabeledString) : [];
};

export const sanitizeLabeledString = (labeledString) => {
    return {
        label: labeledString.label,
        value: labeledString.value,
    }
};

export const sanitizeLabeledDates = (labeledDates) => {
    return labeledDates ? labeledDates.map(sanitizeLabeledDate) : [];
};

export const sanitizeLabeledDate = (labeledDate) => {
    return {
        label: labeledDate.label,
        value: labeledDate.value,
    }
};

export const sanitizeLabeledAddresses = (labeledAddresses) => {
    return labeledAddresses ? labeledAddresses.map(sanitizeLabeledAddress) : [];
};

export const sanitizeLabeledAddress = (labeledAddress) => {
    return {
        label: labeledAddress.label,
        line1: labeledAddress.line1,
        line2: labeledAddress.line2,
        locality: labeledAddress.locality,
        region: labeledAddress.region,
        postalCode: labeledAddress.postalCode,
        country: labeledAddress.country,
    }
};

export const isRoot = (node, user) => {
    const metadata = node.metadata || {};

    return metadata.userId === user.id;
};
